import { useMutation } from '@tanstack/react-query';
import { trackShipment } from '@/api/shipping';

export const useShipping = () => {
  const { mutateAsync: trackShipmentByAWB, isLoading, isError, error } = useMutation({
    mutationFn: trackShipment,
  });

  return {
    trackShipmentByAWB,
    isLoading,
    isError,
    error,
  };
};
